var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BFormCheckbox',_vm._g(_vm._b({attrs:{"checked":_vm.value,"state":_vm.input_state}},'BFormCheckbox',_vm.$attrs,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }